import React from "react";
import Explainer from "../ExplainerModal";

const HomePageExplainer = () => {
  return (
    <Explainer
      title="Home Page Explainer"
      content={
        <>
          <p>
            The homepage provides a <strong>comprehensive overview</strong> of policy distribution and progress across various systems. It includes:
          </p>

          <p>📌 <strong>Policy Distribution Choropleth Map</strong> – A visual representation of policies across different countries or country.</p>
          <p>📊 <strong>Policy Stage Breakdown</strong> – A donut chart showing the distribution of policies across different policy tracking stages.</p>
          <p>📊 <strong>System-Based Policy Distribution</strong> – A horizontal bar chart illustrating the number of policies associated with each system.</p>
          <p>📌 <strong>System Performance Summary</strong> – A snapshot of key policy metrics, including:</p>
          <ul style={{ paddingLeft: "25px" }}>
            <li>✔️ Total number of policies related to each system.</li>
            <li>✔️ Number of policies that have been <strong>approved</strong>.</li>
            <li>✔️ Number of policies that have been <strong>implemented</strong>.</li>
          </ul>
          <p>📌 <strong>Detailed Policy Insights</strong> – Data on how policies are distributed across systems and stages, providing a clear picture of policy progress.</p>

        </>
      }
    />
  );
};

export default HomePageExplainer;
